import styled, { themeGet, device } from "@theme/utils";

export const NewsletterSubscribeWrap = styled.div``;
